// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"127a7839","74":"aaaa2d01","334":"63b4a497","854":"458906c0","951":"7490b941","960":"27abff8d"}[chunkId] + ".css";
};